import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-beam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM353.6 304.6c10-3.1 19.3 5.5 17.7 15.3-8 47.1-71.3 80-123.3 80s-115.4-32.9-123.3-80c-1.7-10 7.9-18.4 17.7-15.3 26 8.3 64.4 13.1 105.6 13.1s79.7-4.8 105.6-13.1zM117.7 231.7c-3.6-1.1-6-4.6-5.7-8.3 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c0.3 3.8-2.1 7.2-5.7 8.3-3.1 1-7.2 0-9.3-3.7l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-1.9 3.2-5.8 4.8-9.3 3.7zM277.7 231.7c-3.6-1.1-6-4.6-5.7-8.3 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c0.3 3.8-2.1 7.2-5.7 8.3-3.1 1-7.2 0-9.3-3.7l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-1.9 3.2-5.8 4.8-9.3 3.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-beam.js
// module id = 1750
// module chunks = 0